import { useState, useCallback } from 'react';
import VoucherService from '../services/VoucherService/VoucherService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useVoucher = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingVouchers: false,
    isCreatingVoucher: false,
    isDeletingVoucher: false,
    isDistributing: false,
  });

  const [modalState, setModalState] = useState({
    showModalGestisciVoucher: false,
  });

  const getVoucherByIdUtente = useCallback(async (id_utente) => {
    setLoadingState(prev => ({ ...prev, isLoadingVouchers: true }));
    try {
      return await VoucherService.findByIdUtente(id_utente);
    } catch (err) {
      handleError(err);
      return [];
    } finally {
      setLoadingState(prev => ({ ...prev, isLoadingVouchers: false }));
    }
  }, []);
  
  const createVoucher = useCallback(async (data) => {
    setLoadingState(prev => ({ ...prev, isCreatingVoucher: true }));
    try {
      await VoucherService.create(data);
      alertService.success("Voucher assegnato con successo", { autoClose: true });
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState(prev => ({ ...prev, isCreatingVoucher: false }));
    }
  }, []);

  const deleteVoucher = useCallback(async (id_utenti_voucher) => {
    setLoadingState(prev => ({ ...prev, isDeletingVoucher: true }));
    try {
      await VoucherService.delete(id_utenti_voucher);
      alertService.success("Voucher eliminato con successo", { autoClose: true });
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState(prev => ({ ...prev, isDeletingVoucher: false }));
    }
  }, []);
  
  const getVoucherSummaryByUtente = useCallback(async (id_utente) => {
    try {
      return await VoucherService.getSummaryByIdUtente(id_utente);
    } catch (err) {
      console.error("useVoucher -> getVoucherSummaryByUtente fallito:", err);
      return [];
    }
  }, []);

  const getVoucherUsage = useCallback(async (id_utenti_voucher) => {
    try {
      const response = await VoucherService.getUsage(id_utenti_voucher);
      return Array.isArray(response) ? response : (response?.data || []);
    } catch (err) {
      handleError(err);
      return [];
    }
  }, []);

  const getVoucherByIdAgenzia = useCallback(async (id_agenzia) => {
    setLoadingState(prev => ({ ...prev, isLoadingVouchers: true }));
    try {
      return await VoucherService.findByIdAgenzia(id_agenzia);
    } catch (err) { handleError(err); return []; }
    finally { setLoadingState(prev => ({ ...prev, isLoadingVouchers: false })); }
  }, []);

  const getVoucherSummaryByAgenzia = useCallback(async (id_agenzia) => {
    try {
      return await VoucherService.getSummaryByIdAgenzia(id_agenzia);
    } catch (err) { console.error(err); return []; }
  }, []);

  const getVoucherByIdSuperpartner = useCallback(async (id_superpartner) => {
    setLoadingState(prev => ({ ...prev, isLoadingVouchers: true }));
    try {
      const response = await VoucherService.findByIdSuperpartner(id_superpartner);
      return Array.isArray(response) ? response : (response?.data || []);
    } catch (err) { handleError(err); return []; }
    finally { setLoadingState(prev => ({ ...prev, isLoadingVouchers: false })); }
  }, []);

  const getVoucherSummaryBySuperpartner = useCallback(async (id_superpartner) => {
    try {
      const response = await VoucherService.getSummaryBySuperpartner(id_superpartner);
      return Array.isArray(response) ? response : (response?.data || []);
    } catch (err) { console.error(err); return []; }
  }, []);
  

  const getVoucherByIdCorso = useCallback(async (data) => {
    setLoadingState(prev => ({ ...prev, isLoadingVouchers: true }));
    try {
        const response = await VoucherService.findVoucherByIdCorso(data);
        return response;
    } catch (error) {
        handleError(error);
    } finally {
        setLoadingState(prev => ({ ...prev, isLoadingVouchers: false }));
    }
  }, []);

  return {
    loadingStateVoucher: loadingState,
    modalStateVoucher: modalState,
    setModalStateVoucher: setModalState,
    getVoucherByIdUtente,
    createVoucher,
    deleteVoucher,
    getVoucherSummaryByUtente,
    getVoucherUsage,
    getVoucherByIdCorso,
    getVoucherByIdAgenzia,
    getVoucherSummaryByAgenzia,
    getVoucherByIdSuperpartner,
    getVoucherSummaryBySuperpartner
  };
};

export default useVoucher;